import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home/Home.vue";

import Pois from "../views/Pois/Pois.vue";

import Routes from "../views/Routes/Routes.vue";

import Map from "../components/Map.vue";

import Settings from "../views/Settings/Settings.vue";
import About from "../views/Settings/About.vue";
import PrivacyPolicyEn from "../views/Legal/PrivacyPolicyEn.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: Home,
  },

  {
    path: "/pois",
    component: Pois,
  },

  {
    path: "/pois/:poi_id",
    component: Map,
  },

  {
    path: "/routes",
    component: Routes,
  },

  {
    path: "/routes/:route_id",
    component: Map,
  },

  {
    path: "/settings",
    component: Settings,
  },

  {
    path: "/settings/about",
    component: About,
  },

  {
    path: "/privacy",
    component: PrivacyPolicyEn,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    if (err.name != "NavigationDuplicated") {
      throw err;
    }
  });
};

export default router;
